import { Wifi, WifiOff, Sun } from "lucide-react";

export default function KeepAliveBadge({ online, wakeLockActive }) {
    return (
        <div className="flex items-center gap-3 text-[10px] tracking-[0.22em] uppercase" data-testid="keepalive-badge">
            <div className={`inline-flex items-center gap-1.5 ${online ? "text-emerald-300" : "text-red-300"}`}>
                {online ? <Wifi size={12} /> : <WifiOff size={12} />}
                <span>{online ? "Live" : "Offline"}</span>
            </div>
            {wakeLockActive && (
                <div className="inline-flex items-center gap-1.5 text-gold/80">
                    <Sun size={12} />
                    <span>Screen on</span>
                </div>
            )}
        </div>
    );
}
